class FormFieldErrorClass {
  constructor() {
    this.hasError = false;
    this.message = "";
    this.body = ""
  }
}

export default FormFieldErrorClass;
